import styled from 'styled-components'

import { ModalStyled } from '@ui/blocks/Modal'

export const DrawerModalStyled = styled(ModalStyled)`
  width: 65vw;
  & .paper {
    font-size: ${(props) => props.theme.typography.pxToRem(16)};
    transition: none;
    box-shadow: none;
    overflow: hidden;
  }
`
